import dayjs, { Dayjs } from "dayjs";

interface Redirection {
  id: string;
  label: string;
  feature: string;
  redirectionText: string;
  redirectionRoute: string;
}
interface ExtendedAttributes {
  guidanceType?: "video" | "written";
  guidanceContent?: string;
  redirection?: Redirection;
  [key: string]: any;
}
export interface Task {
  id: string;
  action: string;
  extendedAttributes?: ExtendedAttributes;
  targetType: string;
  taskName: string;
  displayName: string;
  expiry: string | null;
  description: string;
  points: number;
  threshold: number;
  language?: string;
  code?: string | null;
  path?: string | null;
  startTime: string;
  endTime: string;
  activeStatus: string;
  creationTime: string;
  outletAttributeDTOList: any;
}

export interface ActiveModule {
  id?: number;
  label: string;
  taskName: string;
  subHeading: string;
  icon: string;
  primaryColor?: string;
  redirectionRoute?: string;
  tasks: any[];
}

export interface EditModalProps {
  open: boolean;
  module: ActiveModule | null;
  onClose: () => void;
  onSave: (updatedModule: ActiveModule) => void;
}

export interface TaskFormData {
  taskName: string;
  category: string;
  template: string;
  description: string;
  thresholdValue: string;
  pointsReward: string;
  redirectionPlaceholder: string;
  redirection?: any;
  startDate: string;
  endDate: string;
  activeStatus?: string;
  applyToAll?: boolean;
  outletBifurcationsList?: any[];
  guidanceType: "written" | "video";
  guidanceContent?: string;
  bannerLink?: string;
}

export const getLoyaltyStateFromLocalStorage = () => {
  const storedData = localStorage.getItem("loyalty");
  if (!storedData) return null;

  try {
    const parsedData = JSON.parse(storedData);
    const pageData = parsedData.loyaltyManagement;
    if (!pageData) return null;

    return {
      selectedModule: pageData.selectedModule || null,
      selectedStatuses: pageData.selectedStatuses || [],
      sortBy: pageData.sortBy || "creation-time-new-old",
      startDate: pageData.startDate
        ? dayjs(pageData.startDate)
        : dayjs().startOf("month"),
      endDate: pageData.endDate
        ? dayjs(pageData.endDate)
        : dayjs().endOf("month"),
    };
  } catch {
    return null;
  }
};

export const updateLoyaltyStateInLocalStorage = (state: any) => {
  const storedData = localStorage.getItem("loyalty");
  let parsedData = storedData ? JSON.parse(storedData) : {};

  if (!parsedData.loyaltyManagement) {
    parsedData.loyaltyManagement = {};
  }

  parsedData.loyaltyManagement = {
    ...parsedData.loyaltyManagement,
    ...state,
    startDate: state.startDate?.toISOString?.(),
    endDate: state.endDate?.toISOString?.(),
  };

  localStorage.setItem("loyalty", JSON.stringify(parsedData));
};

export const removeLoyaltyStateFromLocalStorage = () => {
  localStorage.removeItem("loyalty");
};
